import { render, staticRenderFns } from "./card-icon.vue?vue&type=template&id=b7dc7c0c"
import script from "./card-icon.ts?vue&type=script&lang=ts&external"
export * from "./card-icon.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports